module.exports = __webpack_public_path__ + "static/media/vivi-comemorando-esquerda.814e6586.svg";